'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props as ToyCatalogProps } from './toy-catalog.component';
import dynamic from 'next/dynamic';

const DynamicToyCatalogComponent: ComponentType<ToyCatalogProps> = dynamic(
  () => import('./toy-catalog.component')
);

export default DynamicToyCatalogComponent;

export function calculateToyCatalogPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 210 },
    { sinceWidth: 768, height: 230 },
    { sinceWidth: 1024, height: 605 }
  ];

  return {
    heightSinceWidth
  };
}
